import { render } from "./AudienceCards.vue?vue&type=template&id=655a8782&scoped=true"
import script from "./AudienceCards.vue?vue&type=script&lang=js"
export * from "./AudienceCards.vue?vue&type=script&lang=js"

import "./AudienceCards.vue?vue&type=style&index=0&id=655a8782&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-655a8782"
/* hot reload */
if (module.hot) {
  script.__hmrId = "655a8782"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('655a8782', script)) {
    api.reload('655a8782', script)
  }
  
  module.hot.accept("./AudienceCards.vue?vue&type=template&id=655a8782&scoped=true", () => {
    api.rerender('655a8782', render)
  })

}

script.__file = "src/components/AudienceCards.vue"

export default script